document.addEventListener('DOMContentLoaded', function () {
    const adminBar = document.querySelector('#wpadminbar');
    const nav = document.querySelector('#wrapper-navbar > nav');
    if (adminBar && nav) {
        nav.style.marginTop = adminBar.offsetHeight + 'px';
    }
});

jQuery(function ($) {
    $('body').on('added_to_cart', function (event, fragments, cart_hash, $button) {
        console.log('added_to_cart fired');

        var cartToggle = document.querySelector('[data-bs-target="#miniCartOffcanvas"]');

        if (!cartToggle) {
            console.log('Brak przycisku z data-bs-target="#miniCartOffcanvas"');
            return;
        }

        cartToggle.click();
    });
});


jQuery(document).ready(function ($) {
    let $firstHeading = $('.wc-block-product-filters__overlay-content > div').first().find('h3.wp-block-heading');
    $firstHeading.addClass('is-open');
    $firstHeading.next().show();

    $(document).on('click', '.wc-block-product-filters__overlay-content .wp-block-heading', function () {
        let $heading = $(this);
        let $content = $heading.next();

        $content.stop(true, true).slideToggle(300);
        $heading.toggleClass('is-open');
    });


    $('.btn-trigger-filters').click(function () {
        $('button.wc-block-product-filters__open-overlay').trigger('click');
    })
});





// Pageart script


document.addEventListener('DOMContentLoaded', function () {
    /* --- Techlight Lightbox Slider Logic --- */

    // 1. Create Modal HTML Structure dynamically
    const modalHTML = `
        <div id="techlight-slider-modal" class="tl-modal">
            <span class="tl-close">&times;</span>
            <div class="tl-modal-container">
                <div class="tl-main-image-wrapper">
                    <div class="tl-prev">&#10094;</div>
                    <img id="tl-slider-img" src="" alt="Preview">
                    <div class="tl-next">&#10095;</div>
                </div>
                <div id="tl-thumbnails" class="tl-thumbnails-row"></div>
            </div>
        </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    // 2. Select Elements
    const modal = document.getElementById('techlight-slider-modal');
    const modalImg = document.getElementById('tl-slider-img');
    const thumbnailsContainer = document.getElementById('tl-thumbnails');
    let currentGallery = []; // Stores array of image URLs
    let currentIndex = 0;

    // 3. Attach Click Events via event delegation – przeżywa podmianę DOM przez Filter Everything AJAX
    document.addEventListener('click', function (e) {
        const img = e.target.closest('.product-main-row .tl-product-photo-col img.img-fluid');
        if (!img) return;

        e.preventDefault();

        const parentCell = img.closest('.tl-product-photo-col');
        const additionalImagesDiv = parentCell ? parentCell.querySelector('.additional_images') : null;

        currentGallery = [];

        // Użyj data-full jeśli dostępne, fallback na src
        currentGallery.push(img.dataset.full || img.src);

        if (additionalImagesDiv) {
            const hiddenImgs = additionalImagesDiv.querySelectorAll('img');
            hiddenImgs.forEach(hiddenImg => {
                currentGallery.push(hiddenImg.dataset.full || hiddenImg.src);
            });
        }

        currentIndex = 0;
        openModal();
    });

    // cursor:pointer – ustaw przy starcie i po każdym AJAX update
    function setCursorOnProductImages() {
        document.querySelectorAll('.product-main-row .tl-product-photo-col img.img-fluid')
            .forEach(img => { img.style.cursor = 'pointer'; });
    }
    setCursorOnProductImages();
    if (typeof jQuery !== 'undefined') {
        jQuery(document).on('ready', setCursorOnProductImages);
    }

    function openModal() {
        modal.style.display = "flex"; // Use flex to center everything
        updateMainImage();
        renderThumbnails();
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }

    function closeModal() {
        modal.style.display = "none";
        document.body.style.overflow = ''; // Restore scrolling
    }

    function updateMainImage() {
        modalImg.src = currentGallery[currentIndex];
        
        // Update active state in thumbnails
        const allThumbs = thumbnailsContainer.querySelectorAll('img');
        allThumbs.forEach((thumb, index) => {
            if (index === currentIndex) {
                thumb.classList.add('active-thumb');
            } else {
                thumb.classList.remove('active-thumb');
            }
        });
    }

    function renderThumbnails() {
        thumbnailsContainer.innerHTML = ''; // Clear previous
        
        currentGallery.forEach((src, index) => {
            const thumb = document.createElement('img');
            thumb.src = src;
            thumb.classList.add('tl-thumb-item');
            
            // Click on thumbnail to switch main image
            thumb.addEventListener('click', () => {
                currentIndex = index;
                updateMainImage();
            });

            thumbnailsContainer.appendChild(thumb);
        });
    }

    // 4. Navigation Controls
    modal.querySelector('.tl-next').onclick = () => {
        currentIndex = (currentIndex + 1) % currentGallery.length;
        updateMainImage();
    };

    modal.querySelector('.tl-prev').onclick = () => {
        currentIndex = (currentIndex - 1 + currentGallery.length) % currentGallery.length;
        updateMainImage();
    };

    modal.querySelector('.tl-close').onclick = closeModal;

    // Close on click outside the image content
    modal.onclick = (event) => {
        if (event.target === modal) closeModal();
    };
    
    // Keyboard support
    document.addEventListener('keydown', function(e) {
        if (modal.style.display === "flex") {
            if (e.key === "Escape") closeModal();
            if (e.key === "ArrowLeft") document.querySelector('.tl-prev').click();
            if (e.key === "ArrowRight") document.querySelector('.tl-next').click();
        }
    });
});









document.addEventListener('DOMContentLoaded', function () {
    /* --- Filter Dropdown Logic --- */

    const filterBtn = document.getElementById('btn-filter-toggle');
    const filterMenu = document.getElementById('techlight-filter-menu');
    const filterCloseIcon = filterMenu ? filterMenu.querySelector('.filter-close-icon') : null;

    // 1. Toggle Main Filter Menu
    if (filterBtn && filterMenu) {
        filterBtn.addEventListener('click', function (e) {
            e.stopPropagation(); // Stop click from propagating to body
            filterMenu.classList.toggle('filter-visible');
        });

        // Close when clicking the icon inside the menu
        if (filterCloseIcon) {
            filterCloseIcon.addEventListener('click', function() {
                filterMenu.classList.remove('filter-visible');
            });
        }

        // Close when clicking outside the menu
        document.addEventListener('click', function (e) {
            if (!filterMenu.contains(e.target) && e.target !== filterBtn && !filterBtn.contains(e.target)) {
                filterMenu.classList.remove('filter-visible');
            }
        });
    }

    // 2. Accordion Logic (Category, Color, Length)
    const accordionTriggers = document.querySelectorAll('.accordion-trigger');

    accordionTriggers.forEach(trigger => {
        trigger.addEventListener('click', function () {
            const parent = this.closest('.filter-accordion-item');
            
            // Toggle 'open' class on the clicked item
            parent.classList.toggle('open');
        });
    });
});




/* --- UPDATED: Sticky Header & Checkboxes for Multiple Tables --- */

document.addEventListener('DOMContentLoaded', function() {
    
    // 1. SELECT ALL LOGIC (Per Table)
    // We loop through each table container to scope the checkbox logic
    const tableContainers = document.querySelectorAll('.techlight-table-container');

    tableContainers.forEach(container => {
        const masterCheckbox = container.querySelector('.table-thead .techlight-checkbox');
        // We look for checkboxes inside the product rows specifically for THIS table
        const childCheckboxes = container.querySelectorAll('.product-group-box .techlight-checkbox');

        if (masterCheckbox) {
            masterCheckbox.addEventListener('change', function () {
                const isChecked = this.checked;
                childCheckboxes.forEach(checkbox => {
                    checkbox.checked = isChecked;
                });
            });
        }
    });


    // 2. STICKY HEADER LOGIC (Per Table)
    const stickyOffset = 102; 

    // Helper: Lock column widths based on the widest state (scrolled content)
    const freezeColumnWidths = (headerColumns, container) => {
        // We use the full scrollWidth of the container to ensure columns stay wide
        // even if the container visual width shrinks on mobile.
        const scrollWidth = container.scrollWidth;

        headerColumns.forEach(col => {
            const rect = col.getBoundingClientRect();
            // Important: Use rect.width (pixel value) to freeze the size
            const pixelWidth = rect.width;
            
            col.style.flex = '0 0 auto'; // Disable flex shrinking
            col.style.width = pixelWidth + 'px';
            col.style.minWidth = pixelWidth + 'px';
            col.style.maxWidth = pixelWidth + 'px';
        });
    };

    // Helper: Unlock column widths
    const unfreezeColumnWidths = (headerColumns) => {
        headerColumns.forEach(col => {
            col.style.flex = '';
            col.style.width = '';
            col.style.minWidth = '';
            col.style.maxWidth = '';
        });
    };

    // Sync Horizontal Scroll
    const syncHorizontalScroll = (tableHeader, tableContainer) => {
        if (tableHeader.classList.contains('js-sticky-active')) {
            tableHeader.scrollLeft = tableContainer.scrollLeft;
        }
    };

    // Main Scroll Handler
    const handleScroll = () => {
        // Iterate over ALL tables on the page
        tableContainers.forEach(tableContainer => {
            const tableHeader = tableContainer.querySelector('.table-thead');
            if (!tableHeader) return; // Skip if no header found

            // Setup placeholder if not exists
            let placeholder = tableContainer.querySelector('.thead-placeholder');
            if (!placeholder) {
                placeholder = document.createElement('div');
                placeholder.className = 'thead-placeholder';
                placeholder.style.display = 'none';
                placeholder.style.height = tableHeader.offsetHeight + 'px';
                tableContainer.insertBefore(placeholder, tableHeader);
            }

            const headerColumns = Array.from(tableHeader.children);
            const containerRect = tableContainer.getBoundingClientRect();
            const headerHeight = tableHeader.offsetHeight;
            const containerVisibleWidth = tableContainer.clientWidth;

            // Check Sticky Condition for THIS specific table
            if (containerRect.top <= stickyOffset && containerRect.bottom > (headerHeight + stickyOffset)) {
                
                if (!tableHeader.classList.contains('js-sticky-active')) {
                    // Lock widths BEFORE making it fixed
                    freezeColumnWidths(headerColumns, tableContainer);
                    
                    tableHeader.classList.add('js-sticky-active');
                    placeholder.style.display = 'block';
                    
                    // Reset animation
                    tableHeader.style.animation = 'none';
                    tableHeader.offsetHeight; 
                    tableHeader.style.animation = 'slideSticky 0.4s ease-out';
                }

                // Set wrapper width to viewport width (creating a window for horizontal scroll)
                tableHeader.style.width = containerVisibleWidth + 'px';
                tableHeader.style.left = containerRect.left + 'px';
                
                // Sync scroll immediately
                syncHorizontalScroll(tableHeader, tableContainer);

            } else {
                if (tableHeader.classList.contains('js-sticky-active')) {
                    tableHeader.classList.remove('js-sticky-active');
                    placeholder.style.display = 'none';
                    
                    tableHeader.style.width = ''; 
                    tableHeader.style.left = '';
                    tableHeader.style.animation = '';
                    
                    unfreezeColumnWidths(headerColumns);
                }
            }
        });
    };

    // Attach Scroll Listener for Horizontal Sync per table
    tableContainers.forEach(tableContainer => {
        const tableHeader = tableContainer.querySelector('.table-thead');
        if(tableHeader) {
            tableContainer.addEventListener('scroll', () => {
                syncHorizontalScroll(tableHeader, tableContainer);
            });
        }
    });

    // Attach Global Listeners
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
});



jQuery(document).ready(function($) {
    if (typeof $.fn.tooltip === 'function') {
        $('[data-bs-toggle="tooltip"]').tooltip();
    } else {
        console.log('Bootstrap Tooltip function is missing');
    }
});
// ─────────────────────────────────────────────────────────────
// Currency Switcher – dropdown toggle
// ─────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
    var switcher  = document.querySelector('.tl-currency-switcher');
    if (!switcher) return;

    var toggle    = switcher.querySelector('.tl-currency-toggle');
    var dropdown  = switcher.querySelector('.tl-currency-dropdown');
    if (!toggle || !dropdown) return;

    function openDropdown() {
        dropdown.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
        dropdown.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        dropdown.classList.contains('is-open') ? closeDropdown() : openDropdown();
    });

    // Zamknij po kliknięciu poza
    document.addEventListener('click', function (e) {
        if (!switcher.contains(e.target)) closeDropdown();
    });

    // Zamknij po Escape
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDropdown();
    });
});




// Open subcategory on filter function
const manuallyClosedFilters = new Set();

document.addEventListener('click', function(e) {
    const header = e.target.closest('.wpc-filter-header');
    
    if (header) {
        const parentSection = header.closest('.wpc-filters-section');
        if (parentSection) {
            const fid = parentSection.getAttribute('data-fid');
            
            parentSection.classList.toggle('is-open');
            
            if (!parentSection.classList.contains('is-open')) {
                if (fid) manuallyClosedFilters.add(fid);
            } else {
                if (fid) manuallyClosedFilters.delete(fid);
            }
        }
    }
});

function keepActiveFiltersOpen() {
    const activeTerms = document.querySelectorAll('.wpc-term-selected');
    
    activeTerms.forEach(function(term) {
        const parentSection = term.closest('.wpc-filters-section');
        if (parentSection) {
            const fid = parentSection.getAttribute('data-fid');
            if (!manuallyClosedFilters.has(fid)) {
                parentSection.classList.add('is-open');
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', keepActiveFiltersOpen);

if (typeof jQuery !== 'undefined') {
    jQuery(document).on('wpc_ajax_done', function() {
        keepActiveFiltersOpen();
    });
}


// ============================================================
// Przycisk "Odznacz wszystko"
// ============================================================

// Funkcja globalna - może być wywołana z dowolnego miejsca
window.updateUncheckButtonVisibility = function() {
    const uncheckAllBtn = document.querySelector('.btn-uncheck-all');
    if (!uncheckAllBtn) return;
    
    const checkedCount = document.querySelectorAll('.techlight-checkbox:checked').length;
    if (checkedCount > 0) {
        uncheckAllBtn.style.display = 'inline-block';
    } else {
        uncheckAllBtn.style.display = 'none';
    }
};

document.addEventListener('DOMContentLoaded', function() {
    const uncheckAllBtn = document.querySelector('.btn-uncheck-all');
    
    if (!uncheckAllBtn) return;
    
    // Obsługa kliknięcia przycisku
    uncheckAllBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Odznacz wszystkie checkboxy
        document.querySelectorAll('.techlight-checkbox:checked').forEach(checkbox => {
            checkbox.checked = false;
            
            // Wywołaj event change żeby zadziałała normalna logika
            const event = new Event('change', { bubbles: true });
            checkbox.dispatchEvent(event);
        });
        
        // Ukryj przycisk
        window.updateUncheckButtonVisibility();
        
        console.log('✓ Odznaczono wszystkie produkty');
    });
    
    // Nasłuchuj na zmiany checkboxów
    document.addEventListener('change', function(e) {
        if (e.target.classList.contains('techlight-checkbox')) {
            window.updateUncheckButtonVisibility();
        }
    });
    
    // Sprawdź stan przy załadowaniu
    window.updateUncheckButtonVisibility();
});
